import bidello, {component} from "bidello";
import {
    Vector3,
    AmbientLight,
    Object3D,
    TextureLoader,
    Raycaster
} from "three";
import {State, stateManager, States} from "../../services/StateManager";
import camera from "../camera";
import {getCenter} from "../utils/bounding";
import {Planet} from "./Planet";

import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';
import {MeshLoader} from "../utils/meshloader";
import {CelestialBody} from "./CelestialBody";
import {viewport} from "../bidello";
import {assets} from "../../services/assets";


export class Planetarium extends component(Object3D) {


    init() {

        this.name = States.planetarium.DEFAULT_STATE
        stateManager.registerView (this,this.name);
        this.viewGroup = new Object3D();
        this.isMounted = false;
        this.sun = new Planet();
        this.sun.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/sun_diffuse.jpg')))
        this.sun.setRealSize(Planet.REAL_SUN_SIZE,20);
        this.sun.setAtmosphereMaterial(new TextureLoader().load(require('/assets/media/textures/planet-glow.png')),0xEEAA55);
        this.sun.revolutionDays = 30;
        this.sun.setLabel("Soleil")
        this.sun.userData.name = "sun"
        this.viewGroup.add(this.sun);

        this.mercury = new Planet();
        this.mercury.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/mercury_diffuse.jpg')))
        this.mercury.setRealSize(4878,500);
        this.mercury.setSunDistance(70000000);
        this.mercury.revolutionDays = 88;
        this.mercury.orbitalDays = 59;
        this.mercury.setLabel("Mercure")
        this.mercury.userData.name = "mercury"
        this.viewGroup.add(this.mercury);

        this.venus = new Planet();
        this.venus.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/venus_difffuse.jpg')))
        this.venus.setRealSize(12104,500);
        this.venus.setSunDistance(108000000);
        this.venus.revolutionDays = 243;
        this.venus.orbitalDays = 224.7;
        this.venus.setLabel("Venus")
        this.venus.userData.name = "venus"
        this.viewGroup.add(this.venus);

        this.earth = new Planet();
        this.earth.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/earth_diffuse.jpg')))
        this.earth.setRealSize(12576,500);
        this.earth.setSunDistance(150000000);
        this.earth.revolutionDays = 1;
        this.earth.orbitalDays = 364.25;
        this.earth.setLabel("Terre")
        this.earth.userData.name = "earth"
        this.viewGroup.add(this.earth);


        this.mars = new Planet();
        this.mars.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/mzrs_diffuse.jpg')))
        this.mars.setRealSize(6787,500);
        this.mars.setSunDistance(228000000);
        this.mars.setLabel("Mars")
        this.mars.setLabel("Mars")
        this.mars.orbitalDays = 687
        this.mars.revolutionDays = 1
        this.mars.userData.name = "mars"
        this.viewGroup.add(this.mars);

        this.jupiter = new Planet();
        this.jupiter.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/jupiter_diffuse.jpg')))
        this.jupiter.setRealSize(142800,300);
        this.jupiter.setSunDistance(779000000);
        this.jupiter.setLabel("Jupiter")
        this.jupiter.orbitalDays = 4333;
        this.jupiter.revolutionDays = 0.4;

        this.jupiter.userData.name = "jupiter"
        this.viewGroup.add(this.jupiter);

        this.saturn = new Planet();
        this.saturn.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/saturn_diffuse.jpg')))
        this.saturn.setRingMaterial(new TextureLoader(assets).load(require('/assets/media/textures/saturn_ring_diffuse.png')))
        this.saturn.setRingSize(3);
        this.saturn.setAxisAngle(26);

        this.saturn.setRealSize(120000,300);
        this.saturn.setSunDistance(1430000000);
        this.saturn.setLabel("Saturne")
        this.saturn.orbitalDays = 10731;
        this.saturn.revolutionDays = 0.45;
        this.saturn.userData.name = "saturn"
        this.viewGroup.add(this.saturn);

        this.uranus = new Planet();
        this.uranus.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/uranus_difffuse.jpg')))
        this.uranus.setRealSize(51200,500);
        this.uranus.setSunDistance(2880000000);
        this.uranus.setLabel("Uranus")
        this.uranus.orbitalDays = 30670;
        this.uranus.revolutionDays = 0.7
        this.uranus.userData.name = "uranus"
        this.viewGroup.add(this.uranus);

        this.neptune = new Planet();
        this.neptune.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/neptune_diffuse.jpg')))
        this.neptune.setRealSize(48600,500);
        this.neptune.setSunDistance(4500000000);
        this.neptune.setLabel("Neptune")
        this.neptune.orbitalDays = 23360;
        this.neptune.revolutionDays = 0.6;
        this.neptune.userData.name = "neptune"
        this.viewGroup.add(this.neptune);

        this.pluto = new Planet();
        this.pluto.setMaterial(new TextureLoader(assets).load(require('/assets/media/textures/pluto_diffuse.jpg')))
        this.pluto.setRealSize(2300,1000);
        this.pluto.setSunDistance(5910000000);
        this.pluto.setLabel("Pluton")
        this.pluto.userData.name = "pluto"
        this.viewGroup.add(this.pluto);

        this.hubble = new CelestialBody();
        this.hubble.setLabel("Hubble");

        this.hubble.userData.name = "hubble"
        this.earth.addCelestialBody(this.hubble);
        this.hubble.setDistanceFromOrbit(15)

        this.raycaster = new Raycaster()
        this.isActive = false;



        this.defaultStateTween = new TWEEN.Tween(this.viewGroup.position)
            .easing(TWEEN.Easing.Exponential.InOut);

        this.resetStateTween = new TWEEN.Tween(this.viewGroup.position)


        this.mountTween = new TWEEN.Tween(this.viewGroup.position)
            .easing(TWEEN.Easing.Quadratic.InOut);

        this.unmountTween = new TWEEN.Tween(this.viewGroup.position)
            .easing(TWEEN.Easing.Quadratic.InOut);

        this.targetsList = [
            this.sun,
            this.mercury,
            this.venus,
            this.earth,
            this.mars,
            this.jupiter,
            this.saturn,
            this.uranus,
            this.neptune,
            this.pluto,
            this.hubble
        ];
        this.planetsList= [
            this.sun,
            this.mercury,
            this.venus,
            this.earth,
            this.mars,
            this.jupiter,
            this.saturn,
            this.uranus,
            this.neptune,
            this.pluto,
            this.hubble
        ];

        this.meshLoader = new MeshLoader();
        this.meshLoader.loadObject(require('/assets/media/meshes/hubble.glb'),false,(model)=>{

            this.hubble.attachMesh(model);

        })

        this.targetsList.map((planet)=>{

            planet.rotationAllowed = true
            planet.setDaysTillBigBang(5000000)
            planet.setLabelVisibility(false);

        })

        this.isSystemRotate = true;
        this.isPointerAllowed = false;
        this.visible = false;
        this.add(this.viewGroup);
        console.log(camera)


    }

    onPointerEnd(data){

        if (!this.isMounted || !this.isPointerAllowed)return
        this.raycaster.setFromCamera( data.pointer.normalized, camera);
        var intersects = this.raycaster.intersectObjects( this.targetsList,true );
        if (intersects.length>0){

            let parent = intersects[0].object;
            while(parent.name !== "planet"){
                parent = parent.parent;
            }


            const pageState = stateManager.getPageStateByInfo(parent.userData.name);
            if (!pageState)return;
            const state = new State(States.planetarium.PLANET_STATE,pageState.url,parent.userData.name);
            state.data.object = parent.planetGroup
            state.dispatch();
            //if(parent instanceof Planet)bidello.trigger ({name:States.STATE_CHANGE}, {state:States.planetarium.PLANET_STATE,object:parent.planetGroup,url:pageState.url})

        }

    }

    onStateChange (state){

        if (!this.isMounted)return
        if (state.state==States.planetarium.DEFAULT_STATE)this.setDefaultState()
        if (state.state==States.planetarium.PLANET_STATE)this.setPlanetState(state)
        if (state.state==States.planetarium.PLANET_SELECT_STATE)this.setPlanetSelectState(state)
        if (state.state==States.contentDrawer.CLOSE_STATE)this.setDefaultState()

    }

    setDefaultState (){

        this.targetsList.map((planet)=>{

            planet.showOrbit();

        })
        camera.controls.enabled = true;
        this.isPointerAllowed = true;
        const camPos = camera.getCameraPosWithDistanceToSelection([this.sun,this.mercury,this.venus,this.earth],0.75,new Vector3(0,400,200));
        this.defaultStateTween.to({x:0,y:0,z:0},700).start()
        const camLookAt = getCenter(this.sun);
        camera.tweenCameraPosition(camPos)
        camera.tweenLookAtPosition(camLookAt).onComplete(()=>{

            this.targetsList.map((planet)=>{

                planet.setLabelVisibility(true);

            })

        });



    }

    getPlanetByName (name){

        let result = null;
        console.log(this.targetsList,name)
        this.targetsList.map((planet)=>{

            if (planet.userData.name == name) result =  planet;

        })

        return result;

    }

    setPlanetSelectState (state){

        const targetPlanet = this.getPlanetByName(state.info);
        if (targetPlanet){
            const pageState = stateManager.getPageStateByInfo(targetPlanet.userData.name);
            if (!pageState)return;
            const state = new State(States.planetarium.PLANET_STATE,pageState.url,targetPlanet.userData.name);
            window.app.filterDrawer.close();
            state.data.object = targetPlanet.planetGroup
            state.dispatch();

        }

    }

    setPlanetState(data){

        camera.controls.enabled = true;

        this.isPointerAllowed = false;

        this.targetsList.map((planet)=>{

            planet.hideOrbit();

        })
        this.resetStateTween.to({x:0,y:0,z:0},100).start().onComplete(()=>{

            const camPos = camera.getCameraPosWithDistanceToSelection([data.object],1,getCenter(data.object));
            const camLookAt =  getCenter(data.object);
            let offsetX = camera.calculateUnitSize(camPos.distanceTo(camLookAt)).width*0.25;
            if (viewport.isVertical) offsetX = 0;
            this.defaultStateTween.to({x:-offsetX},700).start();

            camera.tweenCameraPosition(camPos).onComplete(()=>{

                this.targetsList.map((planet)=>{

                    planet.setLabelVisibility(false);

                })

            })
            camera.tweenLookAtPosition(camLookAt);

        });
        window.app.filterDrawer.close();

    }

    setHiddenState(){

        //this.scale.set(0,0,0);

    }

    mountView (state = null){


        this.planetsList.map((planet)=>{

            planet.setLabelVisibility(true);

        })

        this.visible = true;
        this.isPointerAllowed = true;
        camera.controls.enabled = true;

        const camPos = camera.getCameraPosWithDistanceToSelection([this.sun,this.mercury,this.venus,this.earth],0.75,new Vector3(0,400,200));
        const camLookAt = getCenter(this.sun);

        camera.position.copy(camPos)
        camera.controls.target.copy(camLookAt);
        camera.controls.update();

        this.isMounted = true;
        this.setMountState().onComplete(()=>{

            if (state){

                state.dispatch();

            }

        })

        stateManager.addBodyState("no-background")
        stateManager.addBodyState("explore_state")



    }

    unmountView (){

        stateManager.removeBodyState("no-background")
        stateManager.removeBodyState("explore_state")
        this.isMounted = false;
        this.visible = false;
        this.planetsList.map((planet)=>{

            planet.setLabelVisibility(false);

        })


    }

    setUnmountState (){

        this.unmountTween.to({y:70},700).start();
        stateManager.removeBodyState('with-filter-drawer')


    }

    setMountState (){

        stateManager.addBodyState('with-filter-drawer')
        this.viewGroup.position.setY(-70)
        return this.mountTween.to({y:0},700).start();


    }


}